/**
 * Error code the guest page gives a protected request it never sent because no reCAPTCHA token
 * could be obtained: the script was blocked, Google failed, or no token arrived in time.
 */
export enum RecaptchaError {
	Unavailable = 'RECAPTCHA_UNAVAILABLE',
}

/**
 * Prefix of the codes the gateway answers with when a protected call it received fails its reCAPTCHA check:
 * token missing, score too low, or token invalid (expired, reused, or Google answered the gateway's check with an error).
 */
export enum RecaptchaErrorCodePrefix {
	Gateway = 'RECAPTCHA-',
}

/** The protected call a missing token stopped, as named in its Bugfender line. */
export enum RecaptchaCall {
	FreedompayInit = 'freedompay-init',
	FreedompaySubmit = 'freedompay-submit',
	PromoApply = 'promo-apply',
	PromoRemove = 'promo-remove',
}

/** Why no token could be obtained, as named in the Bugfender line. */
export enum RecaptchaFailureCause {
	/**
	 * Google's script was not there when the call was made: blocked by a content blocker, unreachable, or still
	 * loading (it loads asynchronously). A script still loading usually heals: a later call in the same session goes
	 * through. A blocked or unreachable one leaves this cause on every call of the session.
	 */
	NoScript = 'no-script',
	/**
	 * Google did not answer within the limit: Google slow or down, or a blocker that let the script load but stopped
	 * what it fetches next, so `ready` never fires.
	 */
	Timeout = 'timeout',
	/** Google answered with an error, or threw. */
	Rejected = 'rejected',
}
